export const ON_CLICK = 'community/PROPOSITION_ANSWER_CARD_ON_CLICK';

export const POST_ANSWER_SUCCESS = 'community/PROPOSITION_ANSWER_CARD_POST_ANSWER_SUCCESS';
export const POST_ANSWER_FAILURE = 'community/PROPOSITION_ANSWER_CARD_POST_ANSWER_FAILURE';
